var _path, _rect, _path2, _rect2, _path3, _rect3, _path4, _path5, _rect4, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDonationLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 89,
    viewBox: "0 0 199 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.315 21V9.894H53.553V7.68H63.741V9.894H59.979V21H57.315ZM64.983 21V6.654H67.629V10.272L67.503 12.162C68.295 11.406 69.303 10.686 70.671 10.686C72.831 10.686 73.785 12.198 73.785 14.718V21H71.139V15.06C71.139 13.476 70.689 12.954 69.717 12.954C68.889 12.954 68.367 13.35 67.629 14.07V21H64.983ZM78.2427 21.252C76.4427 21.252 75.2727 19.992 75.2727 18.264C75.2727 16.122 77.0187 14.988 81.0687 14.538C81.0147 13.548 80.6007 12.81 79.3587 12.81C78.4227 12.81 77.5047 13.206 76.5867 13.764L75.6327 12C76.8207 11.28 78.2427 10.686 79.8447 10.686C82.4007 10.686 83.7147 12.198 83.7147 15.132V21H81.5547L81.3567 19.938H81.2847C80.4027 20.694 79.3947 21.252 78.2427 21.252ZM79.1067 19.182C79.8627 19.182 80.4207 18.84 81.0687 18.21V16.176C78.6027 16.482 77.7927 17.148 77.7927 18.066C77.7927 18.84 78.3327 19.182 79.1067 19.182ZM85.6915 21V10.938H87.8335L88.0495 12.27H88.1035C88.9675 11.406 90.0115 10.686 91.3795 10.686C93.5395 10.686 94.4935 12.198 94.4935 14.718V21H91.8475V15.06C91.8475 13.476 91.3975 12.954 90.4255 12.954C89.5975 12.954 89.0755 13.35 88.3375 14.07V21H85.6915ZM96.5027 21V6.654H99.0947V15.258H99.1847L102.605 10.938H105.521L102.065 15.078L105.827 21H102.965L100.517 16.824L99.0947 18.462V21H96.5027ZM110.868 25.05C110.292 25.05 109.878 24.978 109.5 24.852L109.986 22.818C110.166 22.872 110.436 22.962 110.688 22.962C111.696 22.962 112.272 22.314 112.578 21.414L112.74 20.82L108.816 10.938H111.498L113.082 15.6C113.388 16.518 113.64 17.49 113.946 18.462H114.036C114.252 17.508 114.504 16.554 114.738 15.6L116.142 10.938H118.68L115.098 21.324C114.216 23.682 113.136 25.05 110.868 25.05ZM123.586 21.252C121.048 21.252 118.744 19.308 118.744 15.978C118.744 12.63 121.048 10.686 123.586 10.686C126.106 10.686 128.41 12.63 128.41 15.978C128.41 19.308 126.106 21.252 123.586 21.252ZM123.586 19.11C124.954 19.11 125.71 17.868 125.71 15.978C125.71 14.07 124.954 12.846 123.586 12.846C122.2 12.846 121.444 14.07 121.444 15.978C121.444 17.868 122.2 19.11 123.586 19.11ZM132.928 21.252C130.75 21.252 129.796 19.758 129.796 17.22V10.938H132.442V16.896C132.442 18.444 132.874 18.984 133.864 18.984C134.692 18.984 135.232 18.624 135.916 17.724V10.938H138.544V21H136.384L136.186 19.56H136.132C135.25 20.586 134.296 21.252 132.928 21.252ZM141.706 16.464L141.31 9.822L141.238 7.32H143.884L143.812 9.822L143.434 16.464H141.706ZM142.552 21.252C141.616 21.252 140.914 20.514 140.914 19.524C140.914 18.534 141.616 17.814 142.552 17.814C143.506 17.814 144.208 18.534 144.208 19.524C144.208 20.514 143.506 21.252 142.552 21.252Z",
    fill: "#1EB65B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 99.0957,
    y: 34.5762,
    width: 43.9763,
    height: 43.9763,
    fill: "#1EB65B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.016 54.9307L130.864 79.8902H115.167L123.016 54.9307Z",
    fill: "#FBFBFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 147.528,
    y: 34.5762,
    width: 43.9763,
    height: 43.9763,
    fill: "#1EB65B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169.22 61.9124L191.505 52.6486L191.505 71.1763L169.22 61.9124Z",
    fill: "#FBFBFB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50.6621,
    y: 34.5762,
    width: 43.9763,
    height: 43.9763,
    fill: "#1EB65B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6787 66.5184L94.6382 58.6699L94.6382 74.3669L69.6787 66.5184Z",
    fill: "#FBFBFB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6787 47.7986L94.6382 39.9501L94.6382 55.6472L69.6787 47.7986Z",
    fill: "#FBFBFB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 78.5527,
    width: 43.9763,
    height: 45.9077,
    transform: "rotate(-90 0 78.5527)",
    fill: "#1EB65B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7999 58.834L26.2731 34.2087L41.3268 34.2087L33.7999 58.834Z",
    fill: "#FBFBFB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4855 58.834L6.9586 34.2087L22.0123 34.2087L14.4855 58.834Z",
    fill: "#FBFBFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonationLogo);
export default __webpack_public_path__ + "static/media/donation-logo.ca6529126cc276de4698ecd2e51eec7d.svg";
export { ForwardRef as ReactComponent };